import { api, qs } from "./base";
import type { FindingRow, ListResponse } from "@/common/types";

/** A repo's Inspector findings (optionally narrowed to one status bucket). */
export function listFindings(params: {
  repo: string;
  status?: string;
}): Promise<ListResponse<FindingRow>> {
  return api.get<ListResponse<FindingRow>>(`/findings${qs(params)}`);
}
